const SvgBuildersLogin = props => (
  <svg
    width={453.56}
    height={388.36}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 453.56 388.36"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-1{fill:#b9cb91;}.cls-2{fill:#9fb8c7;}.cls-3{fill:#ecf2f8;}.cls-4{fill:#414f5e;}.cls-5{fill:#87af4a;}.cls-6,.cls-9{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-6{stroke-width:0.79px;}.cls-7{fill:#d0dbe6;}.cls-8{fill:#b7cdba;}.cls-9{stroke-width:0.9px;}.cls-10{fill:#536b7a;}.cls-11{fill:#5e778d;}.cls-12{fill:#13143e;}.cls-13{fill:#b28a67;}.cls-14{fill:#98765a;}.cls-15{fill:#fff;}.cls-16{fill:#f5f7fb;}.cls-17{fill:#915c3c;}.cls-18{fill:#845138;}.cls-19{fill:#c89478;}.cls-20{fill:#d4a180;}"
        }
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          d="M87.21,121.85a15.15,15.15,0,0,1-4.72-8c-.3-1.71.62-4.91,2.4-5.22s3.59,1.61,4,4.09A15.15,15.15,0,0,1,87.21,121.85Z"
        />
        <path
          className="cls-1"
          d="M89.17,129.6a12.79,12.79,0,0,1,2.34-7.67c.92-1.18,3.54-2.41,4.81-1.42s1.1,3.3-.24,5A12.84,12.84,0,0,1,89.17,129.6Z"
        />
        <path
          className="cls-1"
          d="M89.65,138.93a12.87,12.87,0,0,1,5.27-6.06c1.33-.69,4.22-.74,5,.68S99.55,137,97.62,138A12.87,12.87,0,0,1,89.65,138.93Z"
        />
        <path
          className="cls-1"
          d="M89.08,129.85a14.47,14.47,0,0,1-7.77-1.13c-1.35-.65-3.21-2.74-2.64-3.92s2.75-1.3,4.71-.36A14.47,14.47,0,0,1,89.08,129.85Z"
        />
        <path
          className="cls-1"
          d="M90.24,138.89a13.89,13.89,0,0,1-7.83-1c-1.35-.65-3.18-2.79-2.58-4s2.81-1.43,4.77-.48A13.91,13.91,0,0,1,90.24,138.89Z"
        />
        <path
          className="cls-1"
          d="M89.54,151.43a9.27,9.27,0,0,1-6.24-.23c-1-.5-2.31-2.37-1.71-3.62s2.41-1.63,3.9-.9A9.28,9.28,0,0,1,89.54,151.43Z"
        />
        <path
          className="cls-1"
          d="M90,151.4a11.17,11.17,0,0,1,3.67-5.27c1-.72,3.22-1.21,3.9-.28s0,2.59-1.44,3.64A11.18,11.18,0,0,1,90,151.4Z"
        />
        <path
          className="cls-1"
          d="M97.78,201.49a4.52,4.52,0,0,0,1.79,0l-.2-.82.1.41-.1-.41a4.9,4.9,0,0,1-4.08-1.45c-2.4-2.1-4.16-6.12-5.21-11.95-1.44-8-1.48-19.17-.12-33.24,1.57-16.35-.58-25-2-30.78-.37-1.48-.68-2.75-.85-3.85l-.83.13c.17,1.13.49,2.42.86,3.92,1.41,5.69,3.54,14.29,2,30.49-3,31.34,1.41,42.28,5.66,46A6.81,6.81,0,0,0,97.78,201.49Z"
        />
        <path
          className="cls-2"
          d="M331.67,209.88A73.84,73.84,0,0,0,341.73,278a73.66,73.66,0,0,0,40.59-114.79A73.82,73.82,0,0,0,331.67,209.88Z"
        />
        <path
          className="cls-3"
          d="M348.8,279c-31.7,2.06-130,7.66-190.17,4.93C47,278.84-41,310.16,20.55,332.3c17.2,6.18-26.55,55.61,91.15,56.05,103.32.39,206.16-27.68,256-40.21s71.92-29.17,82.18-36.71C458.94,304.81,459.6,271.82,348.8,279Z"
        />
        <path
          className="cls-4"
          d="M402.27,202.68a15.12,15.12,0,0,0,7.59-5.36c1-1.44,1.46-4.74,0-5.76s-3.95,0-5.37,2.09A15.17,15.17,0,0,0,402.27,202.68Z"
        />
        <path
          className="cls-4"
          d="M397.29,209a12.94,12.94,0,0,0,1-8c-.36-1.46-2.25-3.66-3.81-3.28s-2.37,2.56-1.84,4.68A12.91,12.91,0,0,0,397.29,209Z"
        />
        <path
          className="cls-4"
          d="M393,217.31a12.87,12.87,0,0,0-2.33-7.71c-.93-1.18-3.55-2.42-4.82-1.43s-1.12,3.3.23,5A12.87,12.87,0,0,0,393,217.31Z"
        />
        <path
          className="cls-4"
          d="M397.27,209.23a14.44,14.44,0,0,0,7.57,2.17c1.5,0,4.06-1.18,4-2.5s-2-2.33-4.16-2.27A14.45,14.45,0,0,0,397.27,209.23Z"
        />
        <path
          className="cls-4"
          d="M392.49,217a13.92,13.92,0,0,0,7.57,2.31c1.5,0,4.07-1.25,4-2.64s-2-2.46-4.17-2.4A14,14,0,0,0,392.49,217Z"
        />
        <path
          className="cls-4"
          d="M388,228.79a9.29,9.29,0,0,0,5.8,2.36c1.15,0,3.09-1.22,3.05-2.61s-1.53-2.48-3.19-2.43A9.31,9.31,0,0,0,388,228.79Z"
        />
        <path
          className="cls-4"
          d="M387.52,228.56a11.21,11.21,0,0,0-1.19-6.33c-.6-1.07-2.45-2.44-3.45-1.87s-1.06,2.38-.18,3.93A11.26,11.26,0,0,0,387.52,228.56Z"
        />
        <path
          className="cls-4"
          d="M359.83,271.2a4.54,4.54,0,0,1-1.65-.7l.52-.67-.26.34.26-.34a4.9,4.9,0,0,0,4.33.36c3.07-.94,6.32-3.89,9.68-8.79,4.6-6.72,9.24-16.93,13.79-30.37,5.29-15.6,10.83-22.67,14.49-27.34.94-1.2,1.75-2.23,2.36-3.17l.71.46c-.63,1-1.45,2-2.4,3.23-3.63,4.63-9.12,11.62-14.36,27.09-10.13,29.91-18.68,38.1-24.07,39.71A6.8,6.8,0,0,1,359.83,271.2Z"
        />
        <path
          className="cls-5"
          d="M350.86,247.28c-21.68,11.59-35.76,31.31-39.55,52,19.28,8.33,43.5,7.58,65.19-4s35.76-31.31,39.54-52C396.77,234.93,372.54,235.69,350.86,247.28Z"
        />
        <line className="cls-6" x1={409.77} y1={247.42} x2={315.97} y2={297.56} />
        <line className="cls-6" x1={390.48} y1={257.85} x2={406.47} y2={262.7} />
        <line className="cls-6" x1={374.48} y1={266.4} x2={394.19} y2={272.38} />
        <line className="cls-6" x1={358.49} y1={274.95} x2={391.44} y2={284.95} />
        <line className="cls-6" x1={342.5} y1={283.5} x2={374.55} y2={293.22} />
        <line className="cls-6" x1={326.5} y1={292.05} x2={344.35} y2={297.46} />
        <line className="cls-6" x1={392.28} y1={256.58} x2={397.13} y2={240.59} />
        <line className="cls-6" x1={376.28} y1={265.13} x2={383.85} y2={240.2} />
        <line className="cls-6" x1={360.29} y1={273.68} x2={369.76} y2={242.47} />
        <line className="cls-6" x1={344.3} y1={282.23} x2={354.02} y2={250.17} />
        <line className="cls-6" x1={328.3} y1={290.78} x2={336.66} y2={263.24} />
        <path
          className="cls-7"
          d="M310.5,258.81c3-4.69-.83-8.62-15.26-10.58a117.59,117.59,0,0,0-43.1,2.57c29-14.44,62.8-34.63,31.74-36.61-9.69-.61-24.52,4.23-41,11.73,18.31-15.23,28.34-27.68,17.13-29.86-10.41-2-31.46,10.42-53.84,26.88,12.7-13.73,20-25.67,14.19-31.21-4.76-4.52-14.75.83-26.2,10.66.42-8.54-3.22-13.67-11.4-12.54-7.69,1.05-13.83,11-18.17,22.91-7.58-18.32-27.22-29.37-46.86-23.57-23.06,6.8-4,50.71,6.55,71.57Z"
        />
        <path
          className="cls-7"
          d="M126.82,302.09c-.7-3.15-12.32-27.47-1.25-43.41,8.79-12.64,1.62-15.81-5.25-16.13s-13.51,2.44-13.75-6.21c-.8-28.46-19.72-49.64-27.3-31.81-4.1,9.64-15.16,3.18-15.53-4C63,185.25,55.49,175.29,48.09,184,40.81,192.47,33.63,194.26,31,188s-1-19.4-13.62-16c-5,1.33-9.8,13.32-5.75,23.13,2.31,5.59,14.13,20.75-1.18,19.63-15.78-1.14-11,10.85-3.15,14.51,3,1.37,29.19,16.13,19.77,19.28C16,252.27,18.44,262.15,33,265.77c6.6,1.65,22,.85,20.18,6.41s-2.62,13.89,7.55,16.24C78.24,292.48,125.36,295.55,126.82,302.09Z"
        />
        <path
          className="cls-2"
          d="M9.9,142.55a13,13,0,0,0,6.81-2.86c1.05-.93,2.16-3.32,1.3-4.3s-2.9-.6-4.42.75A13,13,0,0,0,9.9,142.55Z"
        />
        <path
          className="cls-2"
          d="M78,226.62a11.75,11.75,0,0,0-4.06-6.16c-1.2-.94-4.12-1.91-5.18-1.1s-.4,2.66,1.34,4A18.76,18.76,0,0,0,78,226.62Z"
        />
        <path
          className="cls-2"
          d="M51.63,161.17a17.1,17.1,0,0,0-5.67-4.7c-1.12-.48-3-.27-3,1s1.49,2.93,3.12,3.62A6.94,6.94,0,0,0,51.63,161.17Z"
        />
        <path
          className="cls-2"
          d="M78.24,227.12s5.14-1.41,8.23-4.42c1.12-1.09,1.87-3.44.41-4s-4.06.37-5.68,1.95A9.28,9.28,0,0,0,78.24,227.12Z"
        />
        <path
          className="cls-2"
          d="M78.35,236.86c6.89-76.2-34.94-125.11-35.36-125.6l-1.1,1c.42.48,41.85,48.95,35,124.51Z"
        />
        <path
          className="cls-2"
          d="M43.84,113.12a15.51,15.51,0,0,0-3.69-8c-1.15-1.22-4.06-2.46-5.19-1.39s-.6,3.49,1.08,5.27A15.55,15.55,0,0,0,43.84,113.12Z"
        />
        <path
          className="cls-2"
          d="M48.34,119.79a14.66,14.66,0,0,0-6.93-4c-1.49-.33-4.3.18-4.58,1.49s1.37,2.79,3.54,3.27A14.64,14.64,0,0,0,48.34,119.79Z"
        />
        <path
          className="cls-2"
          d="M54.94,131.74a11,11,0,0,0-6.31-2.88c-1.29-.06-3.58,1-3.65,2.37s1.51,2.63,3.39,2.72A11,11,0,0,0,54.94,131.74Z"
        />
        <path
          className="cls-2"
          d="M47.68,119.64a10.93,10.93,0,0,0,5-4.77c.53-1.17.43-3.66-.84-4.24s-3,.42-3.76,2.12A11,11,0,0,0,47.68,119.64Z"
        />
        <path
          className="cls-2"
          d="M77.52,199.7a13,13,0,0,0,6.81-2.86c1-.93,2.16-3.32,1.29-4.3s-2.89-.59-4.42.76A12.91,12.91,0,0,0,77.52,199.7Z"
        />
        <path
          className="cls-2"
          d="M55.67,131.29a14.6,14.6,0,0,0,5.67-6c.65-1.44.71-4.39-.61-5s-3.23.72-4.18,2.79A14.58,14.58,0,0,0,55.67,131.29Z"
        />
        <path
          className="cls-2"
          d="M62.61,144.11s4.11-1.49,5.69-4.93c.57-1.25.29-4-1.27-4.7s-3.56.29-4.39,2.1C61.06,140,62.61,144.11,62.61,144.11Z"
        />
        <path
          className="cls-2"
          d="M61.52,144.34s-2.47-3.54-6.27-4.36c-1.38-.29-4,.49-4.37,2.08S52,145.31,54,145.74C57.81,146.55,61.52,144.34,61.52,144.34Z"
        />
        <path
          className="cls-2"
          d="M77.18,200.33a11.8,11.8,0,0,0-4.06-6.17c-1.2-.94-4.12-1.9-5.18-1.09s-.4,2.66,1.34,4A18.7,18.7,0,0,0,77.18,200.33Z"
        />
        <path
          className="cls-2"
          d="M71.83,170.72A9.94,9.94,0,0,0,66,168.86c-1.34,0-4,.74-4.47,1.71s.88,1.79,2.83,1.82A20.58,20.58,0,0,0,71.83,170.72Z"
        />
        <path
          className="cls-2"
          d="M68.26,158a8.4,8.4,0,0,0,3.43-4.4c.4-1.13.45-3.63-.33-4.32s-1.94.2-2.53,1.85A16.8,16.8,0,0,0,68.26,158Z"
        />
        <path
          className="cls-2"
          d="M74.92,186.24s-1.19-4.4-3.68-6.69c-.91-.83-2.84-1.11-3.31.31a5.22,5.22,0,0,0,1.63,4.81A6.21,6.21,0,0,0,74.92,186.24Z"
        />
        <path
          className="cls-2"
          d="M71.65,171.32s4.93-2,7.61-5.43c1-1.22,1.41-3.64-.1-4s-4,.87-5.4,2.65A9.31,9.31,0,0,0,71.65,171.32Z"
        />
        <path
          className="cls-2"
          d="M75.61,186.73s4.67-2,7-5.1c.83-1.14,1-3.38-.51-3.7s-3.86.86-5.07,2.51A7.71,7.71,0,0,0,75.61,186.73Z"
        />
        <path
          className="cls-2"
          d="M78.3,213.55a9.76,9.76,0,0,0-4.07-4.61c-1.14-.7-3.85-1.42-4.75-.8s-.18,2,1.48,3A20.37,20.37,0,0,0,78.3,213.55Z"
        />
        <path
          className="cls-2"
          d="M78.46,213.83s4.68-1.3,7.1-4c.88-1,1.19-3-.3-3.52s-3.82.36-5.1,1.77A6.75,6.75,0,0,0,78.46,213.83Z"
        />
        <path
          className="cls-2"
          d="M68.11,159a14.8,14.8,0,0,0-6.37-4.48c-1.53-.57-4.77-.83-5.48.07s.65,2.35,2.88,3.18A24.15,24.15,0,0,0,68.11,159Z"
        />
        <path
          className="cls-2"
          d="M238,241.76a15,15,0,0,0,4.08-.15,38.06,38.06,0,0,1-12.53-7.31,45.22,45.22,0,0,1-6-6.24c.45-.8.91-1.54,1.35-2.19.91-1.36,2-3.17,3.08-5.29a20.88,20.88,0,0,0,9.1,7.47,26.24,26.24,0,0,1-7.52-10.51c4.05-8,8.79-18.69,12.34-25.72,3.41,4.5,8,7.46,13.13,7.94.47.05.93.06,1.39.07-5.23-1.72-9.64-6.07-12.47-11.88l.27-.47c1.71-2.94,3.75-7,5.93-11.32a16.58,16.58,0,0,1,3.65,1,19.94,19.94,0,0,0-3.11-2.06c1.72-3.39,3.51-6.88,5.27-10,3.33,5.89,8.37,10,14.22,10.89-5.1-3.38-9-9.45-10.69-16.73a30.43,30.43,0,0,1,2.51-3.29c5.55-6.12,23.87-12.2,24.08-10.81.56,3.55,4.56,4.84,10.71,20.25a60.36,60.36,0,0,1,3.11,10.42,23.58,23.58,0,0,1-15.57,4.88,27.37,27.37,0,0,0,7.48,1.79,26.19,26.19,0,0,0,9-.69,87.39,87.39,0,0,1,.28,16,20.15,20.15,0,0,1-11,1.89c-.65-.06-1.29-.15-1.91-.26a21.55,21.55,0,0,0,9.87,3.4,21.83,21.83,0,0,0,2.54.1c-.41,3.59-1,7.16-1.64,10.7a58.85,58.85,0,0,1-3.37,10.73c-.2-.13-.41-.25-.62-.37-1.23-.71-2.45-1.35-3.65-1.92a29.49,29.49,0,0,1,3.52,4.11c-1.4,3.31-3.07,6.84-4.93,10.51a34.05,34.05,0,0,1-11.82-3.5,49.22,49.22,0,0,0,9.8,7.39c-2.34,4.42-4.9,9-7.56,13.52a47.92,47.92,0,0,1-7.92-6.35c.78,2.68,3,5.86,6.37,9-3.93,6.63-8,13.18-11.88,19.21a37.45,37.45,0,0,1-7.7-8.05c-.36,2.77,1.94,6.71,6,10.72l-2.06,3.18C249.44,303,228,288.15,228,288.15s-12.82-21.63-14.1-29.95c-.75-4.78,3.94-19.21,8.56-28.16C225.94,236.63,231.51,241.15,238,241.76Z"
        />
        <path
          className="cls-7"
          d="M228,288.15s-12.82-21.63-14.1-29.95c-.75-4.78,3.94-19.21,8.56-28.16,3.48,6.59,9,11.11,15.52,11.72a15,15,0,0,0,4.08-.15,38.06,38.06,0,0,1-12.53-7.31,45.22,45.22,0,0,1-6-6.24c.45-.8.91-1.54,1.35-2.19.91-1.36,2-3.17,3.08-5.29a20.88,20.88,0,0,0,9.1,7.47,26.24,26.24,0,0,1-7.52-10.51c4.05-8,8.79-18.69,12.34-25.72,3.41,4.5,8,7.46,13.13,7.94.47.05.93.06,1.39.07-5.23-1.72-9.64-6.07-12.47-11.88l.27-.47c1.71-2.94,3.75-7,5.93-11.32a16.58,16.58,0,0,1,3.65,1,19.94,19.94,0,0,0-3.11-2.06c1.72-3.39,3.51-6.88,5.27-10,3.33,5.89,8.37,10,14.22,10.89-5.1-3.38-9-9.45-10.69-16.73a30.43,30.43,0,0,1,2.51-3.29c5.26-5.79,21.95-11.55,23.9-11C275,204.86,254.32,255.28,228.39,288.41,228.13,288.25,228,288.15,228,288.15Z"
        />
        <path
          className="cls-8"
          d="M118.13,231.23c6.36,23.55,22.27,41.58,41.4,49.86,12.36-16.78,17.06-40.37,10.7-63.92s-22.27-41.58-41.4-49.86C116.46,184.09,111.77,207.67,118.13,231.23Z"
        />
        <path
          className="cls-5"
          d="M57.35,273.88c18.09,16.37,41.22,22.92,61.79,19.54,1.32-20.8-7.49-43.18-25.58-59.55S52.34,211,31.77,214.34C30.44,235.13,39.26,257.51,57.35,273.88Z"
        />
        <line className="cls-9" x1={38.44} y1={220.81} x2={115.61} y2={290.65} />
        <line className="cls-9" x1={54.43} y1={235.13} x2={53.62} y2={218.81} />
        <line className="cls-9" x1={67.59} y1={247.05} x2={66.59} y2={226.92} />
        <line className="cls-9" x1={80.74} y1={258.95} x2={79.07} y2={225.3} />
        <line className="cls-9" x1={93.9} y1={270.86} x2={92.27} y2={238.13} />
        <line className="cls-9" x1={107.06} y1={282.77} x2={106.15} y2={264.54} />
        <line className="cls-9" x1={52.66} y1={233.9} x2={36.33} y2={234.71} />
        <line className="cls-9" x1={65.82} y1={245.81} x2={40.36} y2={247.08} />
        <line className="cls-9" x1={78.98} y1={257.72} x2={47.11} y2={259.3} />
        <line className="cls-9" x1={92.14} y1={269.62} x2={59.4} y2={271.26} />
        <line className="cls-9" x1={105.29} y1={281.53} x2={77.17} y2={282.94} />
        <path
          className="cls-4"
          d="M57.21,300.2l-1.1,6.6A69.38,69.38,0,0,1,40.84,308a56.53,56.53,0,0,1-.24-14.31c2.67-23.81,38.18-37,60.91-15.26-4.8,9.11-15.43,18-29.75,23.82a82.49,82.49,0,0,1-11.18,3.61Z"
        />
        <path
          className="cls-8"
          d="M387.51,306.75l4.5,7.1a87.13,87.13,0,0,0,18.25-6.15A71.19,71.19,0,0,0,403.49,291c-14.79-26.21-62.32-24-77.92,12.31,10,8.17,26.7,13.26,46.11,12.9a103.38,103.38,0,0,0,14.7-1.31Z"
        />
        <polygon
          className="cls-7"
          points="348.28 188.49 346.55 312.85 148.49 337.55 147.32 210.28 348.28 188.49"
        />
        <polygon
          className="cls-2"
          points="148.49 337.55 89.47 292.51 88.29 165.25 147.32 210.28 148.49 337.55"
        />
        <polygon
          className="cls-3"
          points="147.32 210.28 88.29 165.25 289.25 143.46 348.28 188.49 147.32 210.28"
        />
        <path
          className="cls-4"
          d="M266.66,176.7l.27,6.12h5s.28-.76.7-.76.81.76,1.29.76h12.68s.22-1.13-.06-1.52a4.58,4.58,0,0,0-1.52-.72c-2.58-.8-9.94-3.29-11.23-6C272.22,171.27,266.66,176.7,266.66,176.7Z"
        />
        <path
          className="cls-4"
          d="M286.62,181.54a4,4,0,0,1,0,1.28H273.9c-.48,0-.94-.76-1.29-.76s-.7.76-.7.76h-5l-.23-1.28Z"
        />
        <path
          className="cls-4"
          d="M228.89,182.87a4.25,4.25,0,0,0-.12,2.13s7.66.95,10.13.3a12,12,0,0,0,2.74-1.42c.18-.11.48-.76.65-.87s.47.14.73,0a9,9,0,0,0,1.17-.9c.68-3.88-.22-5.44-.22-5.44s-4.91-2.4-6.13-.73C235,179.83,230,181,228.89,182.87Z"
        />
        <path
          className="cls-4"
          d="M228.67,183.7c2.36.34,7.32,1,8.24.82a15.41,15.41,0,0,0,7.5-4.26,15,15,0,0,1-.22,1.81,9,9,0,0,1-1.17.9c-.26.18-.42-.16-.73,0s-.47.76-.65.87a12,12,0,0,1-2.74,1.42c-2.47.65-10.13-.3-10.13-.3A5.62,5.62,0,0,1,228.67,183.7Z"
        />
        <path
          className="cls-5"
          d="M274.71,30.13a41.94,41.94,0,0,1,2.89,6.32c4.51,12.6,2.34,46,2.34,46L268,57.47c0,4.66,1.76-29.56,1.24-28.72C270.38,26.85,274.27,29.64,274.71,30.13Z"
        />
        <path
          className="cls-10"
          d="M276.53,176.38l-10.16.34-2.46-92.17,16.72-4.65S287,133.18,276.53,176.38Z"
        />
        <polygon
          className="cls-11"
          points="247.43 88.87 233.94 178.43 245.96 178.77 271.16 82.81 247.43 88.87"
        />
        <path
          className="cls-1"
          d="M247.07,23s26.64.44,28.56,9.11c1.72,7.8,5.86,53.42,5.86,53.42l-34.06,3.34-2.65-48S244,26.14,247.07,23Z"
        />
        <path
          className="cls-5"
          d="M247.07,23s-2.2-.54-2.59,10.6c-.47,13.27,3.34,31.48,5,36.84.41,1.33,5.2,7.93,8,4.23s4.93-18.06.53-36.73C255.21,26,248.92,23,247.07,23Z"
        />
        <polygon
          className="cls-12"
          points="290.29 41.64 290.87 42.35 288.44 49.58 283.79 50.87 282.74 49.87 284.62 43.38 290.29 41.64"
        />
        <path
          className="cls-13"
          d="M274.18,51,281,47.19l2.67-.35-.75,2.35,2.65,1,2.68-.93,1.28-1.74.5,2a4,4,0,0,1-.92,1.75c-.72.77-3.29,5.05-3.29,5.05l-1.95-.43-4.43-1.25-2.88,2.11Z"
        />
        <path
          className="cls-5"
          d="M254.45,72.81S256.08,62,259,60s15-8.83,15-8.83L277,58s-18.66,17.16-20.72,17.58S254.44,73.49,254.45,72.81Z"
        />
        <path
          className="cls-13"
          d="M269.39,18.73c-1.95,5.7-3.2,8.48-3.52,8.76-2.2,2-9.54-2.22-8.73-3.63A52.17,52.17,0,0,0,260,13.31C259.94,12.19,270.55,15.36,269.39,18.73Z"
        />
        <path
          className="cls-14"
          d="M265.78,14.64a20.75,20.75,0,0,0-4.9-1.51,48.57,48.57,0,0,0,0,5.07c.23,3.53,2.91,5.43,4.56,6.87a5.36,5.36,0,0,0,1.36.8c.45-.95,1.23-3,2.63-7.14C269.92,17.2,268,15.71,265.78,14.64Z"
        />
        <path
          className="cls-13"
          d="M274.76,3.43l-.68,16.34s-.15,3.88-1.7,4.31-5.6-.19-7.25-1.63-4.33-3.33-4.57-6.87.49-11.91.49-11.91,1.35-2.66,6.59-.56S274.76,3.43,274.76,3.43Z"
        />
        <path
          className="cls-12"
          d="M274.35.24a3.21,3.21,0,0,1,2.18,2.17,3.26,3.26,0,0,1-1.86,3.26c-1.71.64-8.67-.23-9.53-.61S261.88,4,261.52,2.47c-.23-1,1.39-2.95,4-2.15C269.66,1.59,271.66-.72,274.35.24Z"
        />
        <path
          className="cls-12"
          d="M264.86,2.93l-1.37,6.13-.72,3.69-.85-.06-1.56-.14s-1.94-10.09.53-11A3,3,0,0,1,264.86,2.93Z"
        />
        <path
          className="cls-13"
          d="M261.8,13.37a1.08,1.08,0,0,1-1.19,1l-.66-.06a1.17,1.17,0,0,1-1.09-1.2l.1-2.58a1.07,1.07,0,0,1,1.19-1l.66.05a1.17,1.17,0,0,1,1.09,1.2Z"
        />
        <path
          className="cls-15"
          d="M226.42,262c-4.13,1.21-8.35,1.11-9.71,7.56-2,9.7,3.34,23.6-3.78,37.69-2.27,4.48,42.68,8.65,42.68,8.65L262.35,267s-14.5-6-16.74-6.59C241,259.15,234.68,259.55,226.42,262Z"
        />
        <path
          className="cls-16"
          d="M262.43,267.05c1.7,3.82,6.52,26.73,2.36,32.34-.48.65,2.33,1.51,1.94,4.4-.07.49-.82,2.8-.82,2.8l-3.53,1.08-11-5.73,2-2.6,1,0a2.2,2.2,0,0,0,.59-1.95c-.29-1,2.37-2.87,5.81-20.93C261.7,271.13,262.05,266.21,262.43,267.05Z"
        />
        <path
          className="cls-17"
          d="M234.09,295.76s4.62,8.25,13.76,10.44c1.58.39,1.2,5.38.29,5.17a7.81,7.81,0,0,0-3.44-.41c-4.72.18-11.21-1-15.82-5.17-6.84-6.12-9-8.93-8.48-12.16S234.09,295.76,234.09,295.76Z"
        />
        <path
          className="cls-16"
          d="M217.87,266.27c-1.79,3.22-2.7,8.32-2.41,15.54.23,5.6,5.41,14.57,6.26,17.35a26.77,26.77,0,0,0,1.34,2.5l4.73,5L238.24,299c.06-.05-2-2.79-2.17-3a16.85,16.85,0,0,1-2.14-3.49,18,18,0,0,1-.83-2.89c-1.15-5-2.31-10-3.44-14.94-.67-2.92-1.32-5.85-1.93-8.78C226.63,260.56,219.64,263.08,217.87,266.27Z"
        />
        <path
          className="cls-17"
          d="M246.3,305.86l5.77-.23s1.63,2,1.35,2.55.15,3.58.15,3.58L251,314.12l-2.18-.64s-.19-.93.54-1.05-.83-.85-1.23-1.06S244.46,308.42,246.3,305.86Z"
        />
        <path
          className="cls-18"
          d="M238.38,253.56,235.64,262c-.58,1.81.54,4.07,1.81,5.3a8.17,8.17,0,0,0,5,2.17,7.16,7.16,0,0,0,5-1,1.43,1.43,0,0,0,.31-.24,6.12,6.12,0,0,0,1.18-1.67c.18-.61.39-1.21.54-1.83.52-2.18,1.5-6,1.5-6Z"
        />
        <path
          className="cls-17"
          d="M250.47,261.58a2.17,2.17,0,0,1-2.6,1.61L238.42,261a2.16,2.16,0,0,1-1.61-2.59l3.28-14a2.14,2.14,0,0,1,2.59-1.6l9.46,2.21a2.16,2.16,0,0,1,1.61,2.59Z"
        />
        <path
          className="cls-12"
          d="M253.08,250.46A5.05,5.05,0,0,0,254.6,249c.22-.39.74-2.5.22-3.09-.84-.93-2.5-.16-2.5-.16s1.46,1.33,1.47,1.7S253.08,250.46,253.08,250.46Z"
        />
        <path
          className="cls-12"
          d="M237.65,250.45s-.17-5.72.47-7.23,1.06-2.57,3-2.29c2.94.41,2.83,1,4.44.49s4.61-2.07,5.53-2.08a3,3,0,0,1,3.13,3.73,3.31,3.31,0,0,0,.6,2.91c-.17.22-.66.29-1.68.53-2.94.7-4.58.59-6.47-.4s-5.37-3-6.15-1.63-1.68,6-1.94,6.29S237.94,250.8,237.65,250.45Z"
        />
        <path
          className="cls-17"
          d="M239.64,255.35a.7.7,0,0,1-.86.53l-2-.47a.72.72,0,0,1-.54-.87l.87-3.73a.73.73,0,0,1,.87-.54l2,.48a.72.72,0,0,1,.54.87Z"
        />
        <path
          className="cls-12"
          d="M238.27,251.89l-1.72,7.35c-.39,1.66-.58,5.47,8.8,7.67,5.56,1.3,6.32-2.83,6.63-4.18a12.18,12.18,0,0,0-.65-5.07s-.53,2.27-.53,2.27a4.57,4.57,0,0,0-3.28-3.11c-4.26-1-5.81,1.28-7.68.79C238.4,257.24,237.87,254.62,238.27,251.89Z"
        />
        <path
          className="cls-17"
          d="M244.92,260l2.92.69a.73.73,0,0,0,.86-.54l.1-.41-4.32-1-.1.41A.71.71,0,0,0,244.92,260Z"
        />
        <path
          className="cls-10"
          d="M292.36,315.53c-1.19,3.73-24,18.19-31.85,17.69l-23.53,2c-20.14-1.67-30.83-32.44-30.83-32.44.49-7.86,20.74,2.59,27.85,5.95,12,5.68,18.9,5.07,18.9,5.07,7.49.47,15.43-5.55,24.84-6.11C288.07,307.11,294.23,309.65,292.36,315.53Z"
        />
        <path
          className="cls-12"
          d="M240.85,312.93l0,0v-1l40.6-.75,0,1s0,0,0,0l-.1.18a2.7,2.7,0,0,1-2.51,1.06l-35.33.65a2.65,2.65,0,0,1-2.55-.95Z"
        />
        <path
          className="cls-12"
          d="M250.84,311.74l4.89-20.06a1.33,1.33,0,0,1,1.19-1l28.48-.53a.71.71,0,0,1,.72.94l-4.89,20.05Z"
        />
        <path
          className="cls-12"
          d="M266.76,301a1.37,1.37,0,0,0,1.39,1.82,2.57,2.57,0,0,0,2.29-1.89,1.37,1.37,0,0,0-1.39-1.82A2.57,2.57,0,0,0,266.76,301Z"
        />
        <path
          className="cls-18"
          d="M233.58,340.59c2.83.37,4.84-3,4.84-3l7-6-1.68-3.8-13.88,6.9S230.75,340.22,233.58,340.59Z"
        />
        <path
          className="cls-7"
          d="M238.42,337.4a7.39,7.39,0,0,1-.46,1.84c-.48,1.51-1.13,2.06-1.82,2.29-2.68.9-4.64.58-11.11,2.08s-8.45.64-10.47-2.29-.14-5.36,3-5.73c4.58-.52,7.16-.09,9.54-.55s2.63-1.05,4.06-2,2.81,4.09,1.55,5.31C231.64,339.41,237.52,339.34,238.42,337.4Z"
        />
        <path
          className="cls-15"
          d="M237.14,340.35c-2.68.9-4.64.57-11.11,2.08s-8.45.64-10.48-2.29a3.5,3.5,0,0,1-.55-3.58c-1.39,1-1.81,2.79-.44,4.76,2,2.93,4,3.8,10.47,2.29s8.43-1.18,11.11-2.08a2.47,2.47,0,0,0,1.46-1.4A2.77,2.77,0,0,1,237.14,340.35Z"
        />
        <path
          className="cls-11"
          d="M233.71,331.25s49.06-22.44,51.91-22.58c9.63-.46,7.8,9.37,3.1,14.14-5.55,5.63-48.94,17.23-48.94,17.23Z"
        />
        <polygon
          className="cls-17"
          points="253.63 334.04 239.52 321.66 245.09 315.69 260.56 330.74 253.63 334.04"
        />
        <path
          className="cls-11"
          d="M256.05,323.78s-35.86-30.4-38.24-31.26c-8-2.9-12.59,6-12.19,9,.51,3.9,36.93,34.32,36.93,34.32Z"
        />
        <path
          className="cls-7"
          d="M277,334.14c.84.72,1.06,2.91,1.06,2.91s-11.38,4.82-15.44,5.06a21.15,21.15,0,0,1-4.81-.72c-.31-.07-1-.84-1.34-.92-.56-.13-.67.41-1.15.27a13.8,13.8,0,0,1-2.17-.7c-2.64-5.1-1.92-7.69-1.92-7.69s5.37,1.32,4.42.17c-2-2.47,3.42-5.29,4.71-4C265.53,333.76,274.58,332.07,277,334.14Z"
        />
        <path
          className="cls-15"
          d="M277.7,335.19c-3.5,1.55-10.85,4.76-12.34,4.92-6.06.67-10.4-1.33-13.29-2.49a23.79,23.79,0,0,0,1.09,2.42,13.8,13.8,0,0,0,2.17.7c.48.14.59-.4,1.15-.27.3.08,1,.85,1.34.92a21.15,21.15,0,0,0,4.81.72c4.06-.24,15.44-5.06,15.44-5.06A7.71,7.71,0,0,0,277.7,335.19Z"
        />
        <path
          className="cls-12"
          d="M151.64,143.48a11.21,11.21,0,1,0,5.27-14.77A11.09,11.09,0,0,0,151.64,143.48Z"
        />
        <path
          className="cls-12"
          d="M146,157.48a14.16,14.16,0,1,0,6.65-18.66A14,14,0,0,0,146,157.48Z"
        />
        <path
          className="cls-19"
          d="M157.8,172.68s.41,1.84-8.44,4.08S127,180.12,127,180.12L146.9,173S154.65,170.68,157.8,172.68Z"
        />
        <path
          className="cls-19"
          d="M134.1,179c-4.18,1.2-5.37,3.8-6.84,4.93a28.73,28.73,0,0,0-2.84,2.57c.42-2.05,1.75-2.49,2.26-3.26s.42-.43-1.1-.12c-.86.18-1.92,2.1-2.76,3.23a3.48,3.48,0,0,1-1.28,1.2,19.09,19.09,0,0,1,1.68-3.42A22,22,0,0,1,126.6,180a17.16,17.16,0,0,1,5.62-1.81C134.55,177.89,137.1,178.14,134.1,179Z"
        />
        <path
          className="cls-19"
          d="M126.85,180.06a23.89,23.89,0,0,0-3.41,2.31c-.3.4-1.44,2.59-1.44,2.59a4.39,4.39,0,0,0,1.64-1.39A38.7,38.7,0,0,1,126.85,180.06Z"
        />
        <path
          className="cls-5"
          d="M152.86,170s8.22-1.83,9,3.12c.47,2.81-1.09,4.29-3.59,4.8-4.64.95-10,1.78-10,1.78l-4.45-6.78Z"
        />
        <path
          className="cls-5"
          d="M152.39,165.9l2.29-22.47s-.16-5.88,2-5.76c3.05.17,3.64,5.25,3.9,7.07a60.26,60.26,0,0,1,1.26,14.52c0,5.77.38,12.28,0,16.17-.25,2.67-2.86-.3-5.58-.56C151.16,174.4,152.39,165.9,152.39,165.9Z"
        />
        <polygon
          className="cls-20"
          points="103.08 228.85 95.57 245.13 85.16 245.36 79.9 244.29 91.22 241.6 97.28 226.49 103.08 228.85"
        />
        <path
          className="cls-4"
          d="M94.42,247.7,93,247.37l-.77-1.68-8.4.37-6.76-1.26a1.25,1.25,0,0,1,.45-.69c1.2-.63,7.59-1.07,7.59-1.07s-.91,1-.31,1.35,6.26-.3,7.82-.52c2.67-.38,4.11-1.31,4-1C96.48,243.43,94.42,247.7,94.42,247.7Z"
        />
        <path
          className="cls-10"
          d="M144.64,195.75l-24.54-.65-18.28,40-7.57-3L112.08,184s1.42-3,8.83-3c7.21,0,36.32-.8,39.63.12C168.39,183.24,143.29,189.11,144.64,195.75Z"
        />
        <path
          className="cls-12"
          d="M162.1,129.22a11.21,11.21,0,1,0,5.27-14.77A11.09,11.09,0,0,0,162.1,129.22Z"
        />
        <path
          className="cls-12"
          d="M148.31,122.8c0,.12.09.24.14.36a12,12,0,0,0,5.33,6.43,8.94,8.94,0,0,0,6.45.56,12.59,12.59,0,0,0,2.19-.82l-.36-4.27A8.43,8.43,0,0,0,166,113.79L164.56,111a8.43,8.43,0,0,0-11.27-3.89l-1.4.67c-3.22,1.58-4.71,5.2-4.66,8.66a19.9,19.9,0,0,0,.57,4.81C148,121.74,148.12,122.27,148.31,122.8Z"
        />
        <path
          className="cls-20"
          d="M149.05,112.91a10,10,0,0,1,1.5,1.9c2.92,4.64,7.29,6.91,10.75,5.79a25.14,25.14,0,0,0,4.1,5.26c1.54,1.63,5.1,2.38,5.1,2.38,2.2,3.13,0,12.56-7.89,13.49-4.74.56-5.25-4.59-3.59-7.7.77-1.46,1.29-1.89,1.27-2.95a4.86,4.86,0,0,0-1.27-3.16,2.65,2.65,0,0,0-2.35-1c-.92.29-1.31.52-2.07.81a1.78,1.78,0,0,1-2.22-.64,4.24,4.24,0,0,1-.51-1.5,2.74,2.74,0,0,0-.59-1.29.51.51,0,0,0-.25-.1c-.37,0-.54.16-.9.05a.55.55,0,0,1-.23-.14.63.63,0,0,1-.12-.33c-.12-.9.42-2-.29-3.18A8.8,8.8,0,0,1,149.05,112.91Z"
        />
        <path
          className="cls-15"
          d="M173,187.83s-3.6.74-4.59,1.12c-1.34.5-5.25-.14-5.25-.14s-.5-19.28-1.44-26S159,154.25,159,152.14a23,23,0,0,1,.89-6.76c.59-2.61-1.14-6.08-.56-5.41,1,1.07,4.52,2.73,7.85-.95C167.77,138.38,173,187.83,173,187.83Z"
        />
        <path
          className="cls-1"
          d="M160.2,132.15s-4.89,4.93-4.69,6.55-.3,8.43.82,15.67,2,9,2.21,14.34-1,6.47-.59,13c.34,5.09,1.14,9.57,1.14,9.57a4.22,4.22,0,0,0,4-1.24c1.75-1.89,1.12-19.57.48-23.93s-3.2-15.78-3.05-18.81S161.71,137,162.24,136C163.58,133.65,160.59,132.4,160.2,132.15Z"
        />
        <path
          className="cls-5"
          d="M160.19,131.69a2.45,2.45,0,0,0,.6.66,11.2,11.2,0,0,1,1.44,1.3s-1-.46-1.35.38a16.61,16.61,0,0,0-.74,3.38s-1.81-3-1.38-3.93C159.53,131.76,160.19,131.69,160.19,131.69Z"
        />
        <path
          className="cls-12"
          d="M166.9,143.44A11.71,11.71,0,1,0,174.68,129,11.59,11.59,0,0,0,166.9,143.44Z"
        />
        <polygon
          className="cls-20"
          points="127.29 232.4 126.92 243.8 124.6 246.53 118.41 250.1 113.82 249.27 121.91 243.24 122.5 231.28 127.29 232.4"
        />
        <path
          className="cls-4"
          d="M126.89,246.64l-2.25,1.41-.79-.77-5.74,3.63s-5.22,1.37-6.24.18c-.32-.38.52-1,1.68-1.88.93-.69,2.8-1.83,2.8-1.83s-1.33,1.43.88,1.37c.67,0,4.76-2.6,6.16-3.3,2.53-1.26,3.47-3.65,3.6-3.49C127.32,242.4,126.89,246.64,126.89,246.64Z"
        />
        <path
          className="cls-11"
          d="M175.86,172.29l-3,7-5.09.62-41.07,2.62s-3.67-1.14-6,4.67c-3.33,8.26,1,49.63,1,49.63l6.08-.09,3.29-39s39.47,6.91,50.84,3.42c4.36-1.34,7.69-9.05,7.07-16.83-.49-6.1-4.56-11.71-4.56-11.71Z"
        />
        <path
          className="cls-1"
          d="M170.27,187s-1.9-17.21-3-25.36-.85-21.82-1.09-23.79a28.17,28.17,0,0,0-1.28-4.77s2-4.45,4.57-4.31c2.28.13,9.47,2.54,13,4,2.4,1,1.14,28.42,1.36,29.86.78,5.21,3.34,11.19,5,15.31a60.21,60.21,0,0,1,2.35,8.18S178,184.51,170.27,187Z"
        />
        <path
          className="cls-5"
          d="M169,127.4l-1.93,2.18s-2.71,3.73-1.83,3.21c1.12-.66,2.39,3.23,2.39,3.23l3.59-7.37Z"
        />
        <path
          className="cls-20"
          d="M184.75,169.24s-1.41,4.13-12.77,5.13c-19.49,1.71-22.09-1.31-22.09-1.31L174.08,168S181.24,166.49,184.75,169.24Z"
        />
        <path
          className="cls-20"
          d="M156.23,174.87a25.7,25.7,0,0,0-10,3.52,40.34,40.34,0,0,0-4,2.46c-.73-.33.19-1,.89-1.87.27-.33,1-1,.47-.8a11.37,11.37,0,0,0-3.3,2.26,4.65,4.65,0,0,1-1.82,1.16,22.35,22.35,0,0,1,2.73-3.6,27.65,27.65,0,0,1,5-4.09,44.7,44.7,0,0,1,10.4-2.25C159.45,171.63,160.11,174.36,156.23,174.87Z"
        />
        <path
          className="cls-20"
          d="M145.7,174.64a.32.32,0,0,0-.31-.55,23.29,23.29,0,0,0-4,1.55c-3.2,2.52-3.32,4-3.36,4.61a.33.33,0,0,0,.55.27c.72-.67,2.44-2.28,3.6-2.61C142.87,177.7,144.45,175.76,145.7,174.64Z"
        />
        <path
          className="cls-5"
          d="M178,166l-3.7-25s.92-5.15,2.52-6.91c1.89-2.09,5.5-1.47,5.5-1.47s4.23,3.46,4.53,23.26c.21,13.55,1.45,19.12-4.39,19.71-5.44.55-11.66.89-11.66.89l-4.14-8.18Z"
        />
        <polygon
          className="cls-7"
          points="146.46 182.25 110.63 182.25 110.6 180.61 146.44 180.61 146.46 182.25"
        />
        <path
          className="cls-7"
          d="M130.65,181.47a1,1,0,0,1-.91,1H111.37c-.5,0-1.18-.36-1.79-1.81l-9.08-16.58a.94.94,0,0,1,1.06-1l18.85.56a1.76,1.76,0,0,1,1.19,1.26Z"
        />
        <path
          className="cls-7"
          d="M128.43,182.25h18.12a6.69,6.69,0,0,1-2.93.57h-30.2a6.69,6.69,0,0,1-2.93-.57Z"
        />
      </g>
    </g>
  </svg>
);
export default SvgBuildersLogin;
